import { render, staticRenderFns } from "./promo-sales.vue?vue&type=template&id=5906a595"
import script from "./promo-sales.vue?vue&type=script&lang=js"
export * from "./promo-sales.vue?vue&type=script&lang=js"
import style0 from "./promo-sales.vue?vue&type=style&index=0&id=5906a595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports